import React, { FC } from 'react';
import classNames from 'classnames';
import './Loading.scss';

type LoadingProps = {
  /** Розмір крапки в px */
  size?: number;
  /** Колір крапок (CSS color) */
  color?: string;
  /** ARIA-лейбл для озвучки */
  label?: string;
  /** Виводити інлайн (в рядок з текстом) або як блок */
  inline?: boolean;
  /** Центрувати на всю сторінку (оверлей) */
  fullscreen?: boolean;
};

const Loading: FC<LoadingProps> = ({
  size = 10,
  color = 'currentColor',
  label = 'Loading',
  inline = true,
  fullscreen = false,
}) => {
  const style: React.CSSProperties = {
    // CSS custom properties для стилів
    ['--dot-size' as any]: `${size}px`,
    ['--dot-color' as any]: color,
  };

  const content = (
    <span
      className={classNames('loading', { inline: inline })}
      role="status"
      aria-live="polite"
      aria-label={label}
      style={style}
    >
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </span>
  );

  if (!fullscreen) return content;

  return <div className="fullscreen">{content}</div>;
};

export default Loading;
